// Malzeme (Material) API — /api/materials uclari.
import { logoRequest } from './client';
import { ensureSession } from './session';
import { Material, MaterialUnit, LogoResult } from '../types';

export interface MaterialFilter {
  onlyActive?: boolean;
  code?: string;
  name?: string;
  groupCode?: string;
  producerCode?: string;
  cardType?: number;
}

function toQuery(f: MaterialFilter = {}): Record<string, string | number | boolean> {
  const q: Record<string, string | number | boolean> = {};
  if (f.onlyActive !== undefined) q.OnlyActive = f.onlyActive;
  if (f.code) q.Code = f.code;
  if (f.name) q.Name = f.name;
  if (f.groupCode) q.GroupCode = f.groupCode;
  if (f.producerCode) q.ProducerCode = f.producerCode;
  if (f.cardType !== undefined) q.CardType = f.cardType;
  return q;
}

/** GET /api/materials */
export async function getMaterials(filter: MaterialFilter = {}): Promise<LogoResult<Material[]>> {
  await ensureSession();
  return logoRequest<Material[]>({ url: '/api/materials', method: 'GET', params: toQuery(filter) });
}

/** GET /api/materials/{code} */
export async function getMaterial(code: string): Promise<LogoResult<Material>> {
  await ensureSession();
  return logoRequest<Material>({ url: `/api/materials/${encodeURIComponent(code)}`, method: 'GET' });
}

/** POST /api/materials — ekle/guncelle (insert icin id=0). */
export async function saveMaterial(material: Material): Promise<LogoResult<Material>> {
  await ensureSession();
  return logoRequest<Material>({ url: '/api/materials', method: 'POST', data: material });
}

/** POST /api/materials/bulk */
export async function saveMaterialsBulk(materials: Material[]): Promise<LogoResult<unknown>> {
  await ensureSession();
  return logoRequest<unknown>({ url: '/api/materials/bulk', method: 'POST', data: materials });
}

/** DELETE /api/materials/{id} */
export async function deleteMaterial(id: number): Promise<LogoResult<void>> {
  await ensureSession();
  return logoRequest<void>({ url: `/api/materials/${id}`, method: 'DELETE' });
}

/** GET /api/materials/unit-sets — birim setleri. */
export async function getUnitSets(): Promise<LogoResult<Array<{ code: string; name?: string }>>> {
  await ensureSession();
  return logoRequest({ url: '/api/materials/unit-sets', method: 'GET' });
}

/** GET /api/materials/unit-sets/{unitSetCode}/units */
export async function getUnitSetUnits(unitSetCode: string): Promise<LogoResult<MaterialUnit[]>> {
  await ensureSession();
  return logoRequest<MaterialUnit[]>({ url: `/api/materials/unit-sets/${encodeURIComponent(unitSetCode)}/units`, method: 'GET' });
}
